import { useField } from 'formik';
import ReadonlyFormItem from 'components/new-ui/base/form/ReadonlyFormItem';
import FileTextIconOutlined from 'components/icons/FileTextIconOutlined';
import FormSectionHeader from 'components/new-ui/base/form/FormSectionHeader';

const Form = () => {
    const [field] = useField('form.formType');

    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <FormSectionHeader title="Form" icon={<FileTextIconOutlined />} />
            <ReadonlyFormItem disabled={true} value={field.value} />
        </div>
    );
};

export default Form;
